var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-title-component',{attrs:{"title":"Competitions","subtitle":""}}),_c('section',{staticClass:"section"},[_c('div',{staticClass:"container"},[(_vm.isLoading)?_c('loading-component'):_c('div',[_c('competitionsList',{attrs:{"competitions":_vm.currentCompetitions}})],1)],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }